<!--@created ana.castro 2019.08.19 SABO-1056-->
<!--https://developers.google.com/identity/sign-in/web/build-button-->
<template>
    <div class="g-signin2" data-onsuccess="onSocialSignInSuccess"></div>
</template>

<script>
    import {getErrorMessage} from '../../_helpers';

    export default {
        name: 'GOOGLELoginButton',

        mounted() {

            (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = "https://apis.google.com/js/platform.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'google-js'));
            (function (d, s, name, content) {
                var js, fjs = d.getElementsByTagName(s)[0];
                js = d.createElement(s);
                js.name = name;
                js.content = content;
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'meta', 'google-signin-client_id', '728056915422-uvmksivuc9hp8bo00cte6l86ret3qqbe.apps.googleusercontent.com'));

            window.onSocialSignInSuccess = this.onSocialSignInSuccess;
        },
        methods: {
            onSocialSignInSuccess(response) {
                this.$log.debug("Social Sign | GOOGLE | onSocialSignInSuccess");
                this.$log.debug("Social Sign | GOOGLE | response ", response);
                if (response) {
                    //Defining the Login Provider
                    let provider = "GOOGLE";

                    response = response.getAuthResponse();
                    let code = response.id_token;

                    const {dispatch} = this.$store;

                    if (provider && code) {
                        this.$log.debug("Social Sign | GOOGLE | Success");

                        dispatch('authentication/setLoginProvider', {provider, code});

                        dispatch('authentication/loginSocialProvider', {provider, code});
                    } else {
                        this.$log.debug("Social Sign | GOOGLE | User cancelled login or did not fully authorize");
                        getErrorMessage(undefined, 'Social Sign | GOOGLE', this);
                    }
                }
            }
        }
    }

</script>

<style scoped>

</style>

<!--Segunda forma de implementação. Cheguei a esta ao tentar pedir os scopes a que quero acesso.
Ambas funcionam de igual forma. Deixo aqui a 2a só porque o botão é apresentado de forma diferente. -->
<!--<template>-->
<!--    <div id="my-signin2" data-onsuccess="onSocialSignInSuccess">-->
<!--    </div>-->
<!--</template>-->

<!--<script>-->
<!--    import {getErrorMessage} from '../../_helpers';-->

<!--    export default {-->
<!--        name: 'GOOGLELoginButton',-->

<!--        mounted() {-->
<!--            (function (d, s, id) {-->
<!--                var js, fjs = d.getElementsByTagName(s)[0];-->
<!--                if (d.getElementById(id)) return;-->
<!--                js = d.createElement(s);-->
<!--                js.id = id;-->
<!--                js.src = "https://apis.google.com/js/platform.js?onload=renderButtonG";-->
<!--                fjs.parentNode.insertBefore(js, fjs);-->
<!--            }(document, 'script', 'google-js'));-->
<!--            (function (d, s, name, content) {-->
<!--                var js, fjs = d.getElementsByTagName(s)[0];-->
<!--                js = d.createElement(s);-->
<!--                js.name = name;-->
<!--                js.content = content;-->
<!--                fjs.parentNode.insertBefore(js, fjs);-->
<!--            }(document, 'meta', 'google-signin-client_id', '728056915422-uvmksivuc9hp8bo00cte6l86ret3qqbe.apps.googleusercontent.com'));-->

<!--            window.onSocialSignInSuccess = this.onSocialSignInSuccess;-->
<!--            window.onSocialSignInFailure = this.onSocialSignInFailure;-->
<!--            window.renderButtonG = this.renderButtonG;-->
<!--        },-->
<!--        methods: {-->
<!--            renderButtonG() {-->
<!--                gapi.signin2.render('my-signin2', {-->
<!--                    'width': 240,-->
<!--                    'height': 50,-->
<!--                    'longtitle': true,-->
<!--                    'theme': 'dark',-->
<!--                    'onsuccess': onSocialSignInSuccess,-->
<!--                    'onfailure': onSocialSignInFailure-->
<!--                });-->
<!--            },-->
<!--            onSocialSignInFailure(response) {-->
<!--                this.$log.debug("Social Sign | GOOGLE | onSocialSignInFailure");-->
<!--                this.$log.debug("Social Sign | GOOGLE | response ", response);-->
<!--                getErrorMessage(undefined, 'Social Sign | GOOGLE', this);-->
<!--            },-->
<!--            onSocialSignInSuccess(response) {-->
<!--                this.$log.debug("Social Sign | GOOGLE | onSocialSignInSuccess");-->
<!--                this.$log.debug("Social Sign | GOOGLE | response ", response);-->
<!--                if (response) {-->
<!--                    //Defining the Login Provider-->
<!--                    let provider = "GOOGLE";-->
<!--                    -->
<!--                    response = response.getAuthResponse();-->
<!--                    let code = response.id_token;-->

<!--                    const {dispatch} = this.$store;-->

<!--                    if (provider && code) {-->
<!--                        this.$log.debug("Social Sign | GOOGLE | Success");-->

<!--                        dispatch('authentication/setLoginProvider', {provider, code});-->

<!--                        dispatch('authentication/loginSocialProvider', {provider, code});-->
<!--                    } else {-->
<!--                        this.$log.debug("Social Sign | GOOGLE | User cancelled login or did not fully authorize");-->
<!--                        getErrorMessage(undefined, 'Social Sign | GOOGLE', this);-->
<!--                    }-->
<!--                }-->
<!--            }-->
<!--        }-->
<!--    }-->

<!--</script>-->

<!--<style scoped>-->

<!--</style>-->